// extracted by mini-css-extract-plugin
export default {"banner":"TestUserBanner_banner__TimnY","exit":"TestUserBanner_exit__IegKo"};